import { FeedStrategyProfile } from 'views/planning-prognosis/types/feed-strategy-profile.type';
import { OwnerType } from 'types/shared/owner-type.enum';
import { PlanningPrognosisProfile } from '../views/planning-prognosis/types/planning-prognosis-profile.type';
import { MarketId } from 'types/market-id.enum';

const validateProfileOwner = (
  profile: PlanningPrognosisProfile | FeedStrategyProfile,
  marketId?: MarketId,
  companyId?: string,
  siteId?: string
): boolean => {
  switch (profile.ownerType) {
    case OwnerType.MARKET:
      return profile.ownerMarketId === marketId;
    case OwnerType.COMPANY:
      return profile.ownerCompanyId === companyId;
    case OwnerType.SITE:
      return profile.ownerSiteId === siteId;

    default:
      return false;
  }
};

export default validateProfileOwner;
